import { Component, OnInit } from '@angular/core';
import { NavParams } from '@ionic/angular';

@Component({
  selector: 'app-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss'],
})
export class PopoverComponent implements OnInit {
  popoverText = "";

  constructor(public navParams:NavParams) {
   this.popoverText = this.navParams.data.text;
   }

  ngOnInit() {}

}
